












































































































import { Component, Vue, Prop } from 'vue-property-decorator'
import axios from 'axios'
import { Result } from '../../../modules/class/RegisterResponseInfo'
import RegisteredUserInfo from '../../../modules/class/RegisteredUserInfo'
import Item from '../../../modules/class/Item'
import ErrorFormResponse from '../../../modules/class/ErrorFormResponse'
import { membershipState } from '../../../store/modules/MembershipState'
import JsonUtil from '../../../modules/util/JsonUtil'
import PathUtil from '../../../modules/util/PathUtil'
import GetParameter from '../../../modules/util/GetParameter'
import UidCookie from '../../../modules/util/UidSetCookie'
import { SapLoginInfo, ssoLogin } from '../../../modules/util/SapUtil'

@Component({
  components: {}
})
export default class ChangeMembershipConfirm extends Vue {
  // -------------------------------------------------------------------------------------------------------------------
  // props
  @Prop() private productCategory!: Item[]
  @Prop() private field!: Item[]

  // -------------------------------------------------------------------------------------------------------------------
  // data
  private isLogin = false
  private result: Result = 'success'
  private isErrorMessageAreaVisible = false
  private country: Item[] = []

  private resultError: ErrorFormResponse = {}

  private uidcookie = new UidCookie()
  // -------------------------------------------------------------------------------------------------------------------
  // getter
  get userInfo(): RegisteredUserInfo {
    return membershipState.userInfo
  }

  /**
   * 製品カテゴリ一覧を選択済み製品カテゴリのIDで絞り込み、選択済みの製品名を結合した文字列を返す。
   */
  get selectedProductCategory(): string {
    return this.productCategory
      .filter((p) =>
        this.userInfo.productCategory.find(
          (id: number) => Number(id) === Number(p.id)
        )
      )
      .map((i) => i.title)
      .join(' ,  ')
  }

  /**
   * 分野一覧を選択済み分野のIDで絞り込み、選択済みの分野名を結合した文字列を返す。
   */
  get selectedField(): string {
    return this.field
      .filter((f) =>
        this.userInfo.field.find((id: number) => Number(id) === Number(f.id))
      )
      .map((i) => i.title)
      .join(' ,  ')
  }

  // -------------------------------------------------------------------------------------------------------------------
  // methods
  private setLoginStatus(login: boolean) {
    this.isLogin = login
  }

  private back() {
    window.scrollTo({ top: 0 })
    membershipState.addCurrentChangeMembershipStep('input')
  }

  private async submit() {
    window.gigya.accounts.verifyLogin({
      include: 'preferences',
      callback: this.verifyLoginEditFinishResponse
    })
  }

  /**
   * 興味分野登録コールバック
   */
  private async verifyLoginEditFinishResponse(response: {
    errorCode: number
    UID: string
    UIDSignature: string
    signatureTimestamp: string
  }) {
    if (response.errorCode === 0) {
      const info: SapLoginInfo = {
        UID: response.UID,
        UIDSignature: response.UIDSignature,
        signatureTimestamp: response.signatureTimestamp
      }

      // Cookieに３点セットをセット
      this.uidcookie.setUid(info)

      const form = JSON.stringify({
        update_dttm: this.userInfo.updateDttm,
        accountInfo: info
      })
      try {
        const res = await axios.post(
          PathUtil.makePath('/member/api/user_edit_finish'),
          form
        )
        this.result = res.data.result
        if (this.result === 'success') {
          window.scrollTo({ top: 0 })
          this.isErrorMessageAreaVisible = false
          membershipState.addCurrentChangeMembershipStep('complete')
          // アナリティクス
          // 失敗しても処理継続する
          window.dataLayer = window.dataLayer || []
          window.dataLayer.push({
            'mypage-level': res.data.member_level,
            event: 'MypageLevelChangeEvent'
          })
        } else {
          this.resultError = JsonUtil.jsonToObject<ErrorFormResponse>(
            ErrorFormResponse,
            res.data.errordata || {}
          )
          if (
            this.resultError.common !== undefined ||
            this.resultError.updateDttm !== undefined
          ) {
            this.isErrorMessageAreaVisible = true
            const errorMsgArray =
              this.resultError.common || this.resultError.updateDttm
            if (errorMsgArray !== undefined && errorMsgArray.length > 0) {
              const errorMsg = errorMsgArray.join('')
              const param = new GetParameter('/error.html')
              param.set('msg', errorMsg)
              param.pageTransition()
            }
          }
        }
      } catch (err) {
        if (axios.isAxiosError(err) && err.response?.status === 403) {
          ssoLogin(window.location.href, 'gigya-login-screen')
        } else {
          // TODO: システムエラー
        }
      }
    }
  }
}
